// extracted by mini-css-extract-plugin
export default {"videoContainer":"YouTubeEmbed_videoContainer__CuVrp","gradientShift":"YouTubeEmbed_gradientShift__AdHU6","videoWrapper":"YouTubeEmbed_videoWrapper__dcbwu"};